<template>
  <div>
    <!-- <p class="font-weight-bold">
      <ConsoleLink to="/product-variable" class="text-primary">
        {{ $t('sideBar.product_variable') }} >
      </ConsoleLink> {{ $t('utils.add') }} {{ $t('sideBar.product_variable') }}
    </p> -->

    <a-breadcrumb separator=">">
      <a-breadcrumb-item>
        <ConsoleLink to="/product-variable" class="text-primary">
          {{ $t('sideBar.product_variable') }}
        </ConsoleLink>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('utils.add') }} {{ $t('sideBar.product_variable') }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <AddProductVariable :permission="permission" />
  </div>
</template>

<script>
import AddProductVariable from '@/components/Price/Product-Variable/Add'
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'

export default {
  components: {
    AddProductVariable,
    ConsoleLink,
  },
  computed: {
    permission() {
      return this.$store.getters['user/can']('product-variable')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length || !newValue.includes('WRITE')) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
}
</script>
